export default "__VITE_ASSET__CQ2lBnUh__"